import React from 'react'

const DateSwitcher = ({ currentView, setCurrentView }) => (
	<div className='menu bottom-menu'>
		<button
			className='menu-button'
			onClick={() => setCurrentView('twoDaysAgo')}
		>
			Two Days Ago
		</button>
		<button className='menu-button' onClick={() => setCurrentView('yesterday')}>
			Yesterday
		</button>
		<button className='menu-button' onClick={() => setCurrentView('today')}>
			Today
		</button>
		<button
			className='menu-button detailed-analysis'
			onClick={() => (window.location.href = '/year')}
		>
			Whole Last Year
		</button>
	</div>
)

export default DateSwitcher
